const i = {
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  textDecoration: "none",
  transition: "all",
  position: "relative",
  lineHeight: "body",
  "&:hover, &:active": {
    textDecoration: "underline"
  },
  ":focus-visible": (e) => ({
    ...e.outline({ radius: "sm" })
  }),
  "&[disabled]": {
    cursor: "default",
    pointerEvents: "none",
    color: "disabledText"
  }
}, n = {
  cursor: "default",
  ":focus-visible": {
    outline: "none"
  },
  "&[disabled]": {
    color: "transparent"
  }
}, t = {
  fontWeight: "bold",
  "&:hover, &:active": {
    textDecoration: "none"
  }
}, o = {
  textDecoration: "underline",
  "&:hover": {
    opacity: 0.8
  },
  "&:active": {
    opacity: 1
  }
}, r = {
  color: "inherit",
  lineHeight: "inherit"
};
export {
  t as activeLink,
  r as inheritedLink,
  i as link,
  n as loadingLink,
  o as underlinedLink
};
